import { useSession } from './useSession'

export function useCurrentUser() {
  return useSession().session?.user
}
